import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { templateMigrator } from '../helpers';
import { getTemplateVersion } from '../requests';
import type { GetTemplateRequestType } from '../types';

export const useGetTemplateVersion = (
  {
    pathParams: { templateId, version },
  }: {
    pathParams: GetTemplateRequestType['pathParams'];
  },
  options?: {
    enabled?: boolean;
  },
) =>
  useQuery({
    enabled: Boolean(templateId && version),
    queryKey: [
      API_QUERY_KEYS.templateVersion,
      {
        templateId: Number(templateId),
        version,
      },
    ],
    queryFn: () =>
      getTemplateVersion({
        pathParams: { templateId, version },
      }).then(templateMigrator),
    ...options,
  });
